import { 
    GAME_FACT_BASKET_STOP,
    GAME_FACT_BASKET_FREETHROW,
    GAME_FACT_BASKET_TWOPOINTS,
    GAME_FACT_BASKET_THREEPOINTS,
    GAME_FACT_BASKET_TECHNICAL,
    GAME_FACT_BASKET_FAULT,
    GAME_FACT_BASKET_COMMENT,
    GAME_FACT_BASKET_TIMEOUT,
    GAME_FACT_BASKET_STAR
} from '../../constants.js'
import { FreeThrowDto } from '../../gamefacts/basket/FreeThrowDto.js'
import { StopDto } from '../../gamefacts/basket/StopDto.js'
import { TwoPointsDto } from '../../gamefacts/basket/TwoPointsDto.js'
import { ThreePointsDto } from '../../gamefacts/basket/ThreePointsDto.js'
import { FaultDto } from '../../gamefacts/basket/FaultDto.js'
import { TechnicalDto } from '../../gamefacts/basket/TechnicalDto.js'
import { CommentDto } from '../../gamefacts/basket/CommentDto.js.js'
import { TimeoutDto } from '../../gamefacts/basket/TimeoutDto.js'
import { StarDto } from '../../gamefacts/basket/StarDto.js'

export const basketResolvers = {
    [GAME_FACT_BASKET_STOP]: (event) => new StopDto(event),
    [GAME_FACT_BASKET_FREETHROW]: (event) => new FreeThrowDto(event),
    [GAME_FACT_BASKET_TWOPOINTS]: (event) => new TwoPointsDto(event),
    [GAME_FACT_BASKET_THREEPOINTS]: (event) => new ThreePointsDto(event),
    [GAME_FACT_BASKET_FAULT]: (event) => new FaultDto(event),
    [GAME_FACT_BASKET_TECHNICAL]: (event) => new TechnicalDto(event),
    [GAME_FACT_BASKET_TIMEOUT]: (event) => new TimeoutDto(event),
    [GAME_FACT_BASKET_STAR]: (event) => new StarDto(event),
    [GAME_FACT_BASKET_COMMENT]: (event) => new CommentDto(event),
}